import type { CSSProperties } from 'react';
import { DAALUU_JANLII_PICK_MS, DAALUU_KINDS } from '@big2/shared';
import { MixingHand } from './DaaluuShuffleTable.js';
import { DaaluuTile } from './DaaluuTile.js';

export interface JanliiChoicePosition {
  kindId: string;
  left: number;
  top: number;
  width: number;
}

export function DaaluuJanliiReveal({ kindId, player, mn, choices }: {
  kindId: string; player: string; mn: boolean; choices: JanliiChoicePosition[];
}) {
  const kind = DAALUU_KINDS.find(candidate => candidate.id === kindId);
  const choice = choices.find(candidate => candidate.kindId === kindId);
  if (!kind || !choice) return null;
  return <div className="daaluu-janlii-pick" role="status" aria-label={`${player} ${mn ? 'жанлий сонголоо' : 'picked Janlii'}: ${kind.name}`}
    style={{ '--janlii-pick-duration': `${DAALUU_JANLII_PICK_MS}ms` } as CSSProperties}>
    <div className="daaluu-janlii-option is-picked"
      style={{ left: choice.left, top: choice.top, width: choice.width }} aria-hidden="true">
      <DaaluuTile tile={{ id: `janlii-reveal-${kindId}`, kindId }} />
      <span className="daaluu-janlii-picking-hand"><MixingHand /></span>
    </div>
  </div>;
}
